import React from 'react';
import TextField from 'material-ui/TextField/TextField';
import { MenuItem } from 'material-ui/Menu/index';
import { translate } from 'react-i18next';
import SearchTransferController from './Transfers/SearchTransferController';
import AbstractSearchForm from './AbstractSearchForm';

class TimePicker extends AbstractSearchForm {
    hourValue = '';
    minutesValue = '';
    constructor(props) {
        super(props);
        this.controller = new SearchTransferController(this.props, this);
        this.state = this.controller.getInitialState();
    }

    render() {
        let { t, label, hourValue, minutesValue, disabled } = this.props;
        this.hourValue = String(hourValue).length === 1 ? '0' + String(hourValue) : String(hourValue);
        this.minutesValue = String(minutesValue).length === 1 ? '0' + String(minutesValue) : String(minutesValue);
        const hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
        const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

        return (
            <div className={'cmsSelectHours ' + (disabled ? 'disabled' : '')}>
                <div style={{ height: '18px', marginBottom: '1px' }}>
                    <label>{label}</label>
                </div>
                <TextField select
                    className="selectHour"
                    InputProps={{ disableUnderline: true }}
                    value={this.hourValue}
                    disabled={disabled}
                    onChange={(event) => this.props.onChange(event.target.value, this.minutesValue)}>
                    {
                        hours.map(option => (
                            <MenuItem key={option} value={option}>
                                {' '}
                                {option}{' '}
                            </MenuItem>
                        ))
                    }
                </TextField>
                <TextField select
                    className="selectHour"
                    InputProps={{ disableUnderline: true }}
                    value={this.minutesValue}
                    disabled={disabled}
                    onChange={(event) => this.props.onChange(this.hourValue, event.target.value)}>
                    {
                        minutes.map(option => (
                            <MenuItem key={option} value={option}>
                                {' '}
                                {option}{' '}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </div>
        );
    }
}



export default translate('translations')(TimePicker);


// WEBPACK FOOTER //
// ./src/components/SearchContent/TimePicker.js